<template>
  <div class="gs-app gs-refresh-controls gv-video-settings-panel">
    <div v-if="$store.getters.canUseStorage && encodingAccounts && encodingAccounts.length === 0">
      <div class="w-full flex videoEncoder">
        <div class="w-full flex flex-col flex-nowrap items-center justify-center">
          <div class="gv-encoder__badge">
            <img
              src="../../assets/images/videos/Storage-Icon.png"
              alt="Storage-Icon"
            />
          </div>
          <h3 class="gv-encoder__heading">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_lets_setup_encoder'
              )
            }}
          </h3>
          <p class="gv-encoder__copy">
            <strong class="gv-encoder__copy-strong">
              {{
                $t(
                  'frontend_groovevideo_members_settings_index_promembers_get'
                )
              }} </strong
            ><br />
            {{
              $t(
                'frontend_groovevideo_members_settings_index_as_you_are'
              )
            }}
          </p>
          <p class="gv-encoder__copy">
            <strong class="gv-encoder__copy-strong">OR</strong>
            <br />
            <span>
              {{
                $t('frontend_groovevideo_members_settings_index_connect_you_encoder')
              }}
            </span>
          </p>
          <div class="gv-encoder__providers smallBox">
            <div
              class="gv-encoder__provider"
              @click="addEncodeIntegration(1)"
            >
              <img
                src="../../assets/images/videos/coconut-logo-white.png"
                alt="coconut-logo-white"
              />
              <a href="#" class="gv-encoder__provider-link">
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_connect_coconut'
                  )
                }}
              </a>
            </div>
            <div
              class="gv-encoder__provider"
              @click="addEncodeIntegration(2)"
            >
              <img
                src="../../assets/images/videos/Encoding_90grey.png"
                alt="Encoding_90grey"
              />
              <a href="#" class="gv-encoder__provider-link">
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_connect_encoding'
                  )
                }}
              </a>
            </div>
          </div>
          <p class="gv-encoder__help">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_need_help_connecting'
              )
            }}
            <a href="#" class="gv-encoder__help-link">
              {{
                $t(
                  'frontend_groovevideo_members_settings_index_visit_help_center'
                )
              }}
            </a>
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-if="encodingAccounts.length >= 1"
        class="flex flex-row justify-end w-full gv-encoder__toolbar"
      >
        <div class="text-right">
          <dropdown-button class="w-full">
            <span slot="link" class="gv-encoder__add-trigger">
              <gs-icon name="plus" size="15" />
              <span>
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_add_new_encoder'
                  )
                }}
              </span>
              <gs-icon name="chevron-down" size="15" />
            </span>
            <div slot="dropdown" class="gv-encoder__menu">
              <div
                v-for="(integration, index) in encodingIntegration"
                :key="index"
                class="gv-encoder__menu-item"
                @click="addEncodeIntegration(integration.id)"
              >
                {{ integration.name }}
              </div>
            </div>
          </dropdown-button>
        </div>
      </div>
      <div>
        <div v-if="encodingAccounts.length > 0" class="gv-encoder__grid">
          <gs-card
            v-for="(encoding, encodingIndex) in encodingAccounts"
            :key="encodingIndex"
            class="storage-section gv-encoder__account"
          >
            <div class="gv-encoder__account-logo">
              <img
                v-if="encoding.type == 1"
                src="@/assets/images/logo/coconut.png"
                alt="content-img"
                class="responsive"
              />
              <img
                v-else
                src="@/assets/images/logo/Encoding.png"
                alt="content-img"
                class="responsive"
              />
            </div>
            <div class="gv-encoder__account-footer">
              <div class="gv-encoder__account-name">
                {{ encoding.integration_name }}
              </div>
              <gs-button
                variant="ghost"
                size="sm"
                class="is-destructive"
                :aria-label="$t('frontend_delete')"
                @click="deleteEncoder(encoding.id)"
              >
                <gs-icon name="trash" size="15" />
              </gs-button>
            </div>
          </gs-card>
        </div>
        <div v-else class="w-full">
          <div class="w-full flex videoEncoder">
            <div
              class="w-full flex flex-col flex-nowrap items-center justify-center"
            >
              <div class="gv-encoder__badge">
                <img
                  src="../../assets/images/videos/Storage-Icon.png"
                  alt="Storage-Icon"
                />
              </div>
              <h3 class="gv-encoder__heading">
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_lets_setup_encoder'
                  )
                }}
              </h3>
              <p class="gv-encoder__copy">
                <strong class="gv-encoder__copy-strong">
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_free_encoder'
                    )
                  }} </strong
                ><br />
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_free_members_need'
                  )
                }}
              </p>
              <div class="gv-encoder__actions">
                <gs-button
                  v-if="this.$store.getters.canUseStorage"
                  variant="primary"
                  size="lg"
                >
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_upgrade_to_pro'
                    )
                  }}
                </gs-button>
                <gs-button v-else variant="primary" size="lg">
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_pro_users_get_free'
                    )
                  }}
                </gs-button>
              </div>
              <div class="gv-encoder__providers smallBox">
                <div
                  class="gv-encoder__provider"
                  @click="addEncodeIntegration(1)"
                >
                  <img
                    src="../../assets/images/videos/coconut-logo-white.png"
                    alt="coconut-logo-white"
                  />
                  <a href="#" class="gv-encoder__provider-link">
                    {{
                      $t(
                        'frontend_groovevideo_members_settings_index_connect_coconut'
                      )
                    }}
                  </a>
                </div>
                <div
                  class="gv-encoder__provider"
                  @click="addEncodeIntegration(2)"
                >
                  <img
                    src="../../assets/images/videos/Encoding_90grey.png"
                    alt="Encoding_90grey"
                  />
                  <a href="#" class="gv-encoder__provider-link">
                    {{
                      $t(
                        'frontend_groovevideo_members_settings_index_connect_encoding'
                      )
                    }}
                  </a>
                </div>
              </div>
              <p class="gv-encoder__help">
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_need_help_connecting'
                  )
                }}
                <a href="#" class="gv-encoder__help-link">
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_visit_help_center'
                    )
                  }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <gs-named-modal
      name="add-coconut-account-modal"
      :title="$t('frontend_groovevideo_add_coconut_account_details')"
      @closed="resetModal"
    >
      <div class="gs-app gs-refresh-controls flex flex-col m-6 gv-video-settings-modal-body">
        <gs-field
          :label="$t('frontend_groovevideo_members_settings_index_integration_name')"
        >
          <text-input
            v-model="model.name"
            :validator="$v.model.name"
            value="model.name"
            :attribute="$t('frontend_name')"
            :placeholder="
              $t(
                'frontend_groovevideo_members_settings_index_integration_name'
              )
            "
          />
        </gs-field>
        <gs-field :label="$t('frontend_groovevideo_members_settings_index_apikey')">
          <text-input
            v-model="model.apikey"
            :validator="$v.model.apikey"
            value="model.apikey"
            :attribute="$t('frontend_groovevideo_videos_integration_key')"
            :placeholder="
              $t('frontend_groovevideo_members_settings_index_apikey')
            "
          />
        </gs-field>
        <div class="flex flex-row w-full justify-end gv-video-settings-modal-actions">
          <gs-button
            class="text-center w-40"
            size="lg"
            variant="primary"
            @click="saveCoconutAccount()"
          >
            {{ $t('frontend_groovevideo_members_settings_create') }}
          </gs-button>
        </div>
      </div>
    </gs-named-modal>

    <gs-named-modal name="add-encoding-account-modal" :title="$t('frontend_groovevideo_add_details')" @closed="resetModal">
      <div class="gs-app gs-refresh-controls flex flex-col m-6 gv-video-settings-modal-body">
        <gs-field
          :label="$t('frontend_groovevideo_members_settings_index_integration_name')"
        >
          <text-input
            v-model="model.integration_name"
            :validator="$v.model.integration_name"
            value="model.integration_name"
            :attribute="$t('frontend_name')"
            :placeholder="
              $t(
                'frontend_groovevideo_members_settings_index_enter_integration_name'
              )
            "
          />
        </gs-field>
        <gs-field :label="$t('frontend_groovevideo_members_settings_index_user_id')">
          <text-input
            v-model="model.user_encode_id"
            :validator="$v.model.user_encode_id"
            value="model.apikey"
            :attribute="$t('frontend_groovevideo_members_settings_index_user_id')"
            :placeholder="
              $t('frontend_groovevideo_members_settings_index_user_id')
            "
          />
        </gs-field>
        <gs-field :label="$t('frontend_groovevideo_members_settings_index_user_key')">
          <text-input
            v-model="model.user_encode_key"
            :validator="$v.model.user_encode_key"
            value="model.user_encode_key"
            :attribute="$t('frontend_groovevideo_videos_integration_key')"
            :placeholder="
              $t('frontend_groovevideo_members_settings_index_user_key')
            "
          />
        </gs-field>
        <div class="flex flex-row w-full justify-end gv-video-settings-modal-actions">
          <gs-button
            class="text-center w-40"
            size="lg"
            variant="primary"
            @click="saveEncodingComCredential()"
          >
            {{ $t('frontend_groovevideo_members_settings_create') }}
          </gs-button>
        </div>
      </div>
    </gs-named-modal>
  </div>
</template>
<script>
import Swal from 'sweetalert2';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import Encoder from '@/models/Encoder';

export default {
  props: {
    encodingAccounts: {
      required: true,
    }, 
  },
  components: {},
  data () {
    return {
      model: {
        name: '',
        apikey: '',
        integration_name: '',
        user_encode_id: '',
        user_encode_key: '',
      },
    };
  },
  validations: {
    model: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      apikey: {
        required,
        maxLength: maxLength(100),
      },
      integration_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      user_encode_id: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      user_encode_key: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
    },
  },
  computed: {
    encodingIntegration() {
      return [
        { name: this.$t('frontend_groovevideo_add_coconut_encoding'), id: 1 },
        {
          name: this.$t('frontend_groovevideo_add_encoding_integration'),
          id: 2,
        },
      ];
    },
  },
  methods: {
    addEncodeIntegration(id) {
      if (id === 1) {
        this.$root.$emit('modal-open', 'add-coconut-account-modal');
      } else if (id === 2) {
        this.$root.$emit('modal-open', 'add-encoding-account-modal');
      }
    },
    resetModal () {
      this.model = {
        name: '',
        apikey: '',
        integration_name: '',
        user_encode_id: '',
        user_encode_key: '',
      };
      this.$v.$reset();
    },
    async saveCoconutAccount() {
      this.$v.model.name.$touch();
      this.$v.model.apikey.$touch();
      if (!this.$v.model.name.$invalid &&
        !this.$v.model.apikey.$invalid) {
        this.$emit('setIsLoading', true);
        this.encoder = new Encoder({});
        this.encoder.type = 1;
        this.encoder.apikey = this.model.apikey;
        this.encoder.integration_name = this.model.name;

        const self = this;
        this.encoder
          .save()
          .then((response) => {
            self.encoder = response.data;
            self.encodingAccounts.push(self.encoder);
            self.$root.$emit('modal-close', 'add-coconut-account-modal');
            self.resetModal();
            self.$emit('setIsLoading', false);
          })
          .catch(() => {
            self.$emit('setIsLoading', false);
          });
      }
    },


    saveEncodingComCredential() {
      this.$v.model.integration_name.$touch();
      this.$v.model.user_encode_id.$touch();
      this.$v.model.user_encode_key.$touch();

      if (
        !this.$v.model.integration_name.$invalid &&
        !this.$v.model.user_encode_id.$invalid &&
        !this.$v.model.user_encode_key.$invalid
      ) {
        this.$emit('setIsLoading', true);
        this.encoder = new Encoder({});
        this.encoder.type = 2;
        this.encoder.integration_name = this.model.integration_name;
        this.encoder.user_encode_id = this.model.user_encode_id;
        this.encoder.user_encode_key = this.model.user_encode_key;

        const self = this;

        this.encoder
          .save()
          .then((response) => {
            if (typeof response.status !== 'undefined' && !response.status && response.message) {
              Swal.fire(this.$t('frontend_error'), response.message, 'error');
            } else {
              self.encoder = response.data;
              self.encodingAccounts.push(self.encoder);
              self.$root.$emit('modal-close', 'add-encoding-account-modal');
              self.resetModal();
            }

            self.$emit('setIsLoading', false);
          })
          .catch(() => {
            self.$emit('setIsLoading', false);
          });
      }
    },
    async deleteEncoder (id) {
      const { value: accept } = await Swal.fire({
        title: this.$t('frontend_sure'),
        text: this.$t('frontend_non_revertable'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('frontend_delete_confirm'),
      });
      
      if (accept) {
        this.$emit('setIsLoading', true);

        try {
          const encoder = await Encoder.$find(id);
          const response = await encoder.delete();

          if (response && response.data && response.data.status) {
            const deletedEncoder = this.encodingAccounts.findIndex(
              (el) => el.id === id
            );
            this.encodingAccounts.splice(deletedEncoder, 1);
          } else {
            Swal.fire(this.$t('frontend_groovevideo_warning_title'), this.$t('frontend_groovevideo_encoder_already_in_use'), 'warning');
          }

        } catch (err) {
          Swal.fire(
            this.$t('frontend_error'),
            this.$t('frontend_backend_error'),
            'error'
          );
        }

        this.$emit('setIsLoading', false);
      }
    },
  },
};
</script>
<style>
.videoEncoder h3 {
  font-size: 20px !important;
  color: #191d3a;
}
.storage-section {
  width: 23.5% !important;
  height: 267px !important;
  min-width: 250px !important;
}
.storage-section .rounded-md-top {
  border-radius: 4px 4px 0px 0px !important;
}
.smallBox div {
  width: 182px;
  height: 104px;
  border-radius: 5px;
}
</style>

<style>
.gv-video-settings-panel .videoEncoder { padding: 24px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface-subtle); }
.gv-video-settings-panel .storage-section { border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); box-shadow: var(--gs-shadow-sm); }
.gv-video-settings-modal-body { gap: 12px; max-width: 720px; }
@media (max-width: 640px) { .gv-video-settings-panel .videoEncoder { padding: 16px; } .gv-video-settings-panel .videoEncoder .w-2\/5 { width: 100% !important; } .gv-video-settings-modal-body { margin: 16px !important; } }
</style>

<style>
.gv-video-settings-panel .gv-encoder__badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: var(--gs-muted);
}

.gv-video-settings-panel .gv-encoder__heading {
  margin: 20px 0 8px;
  color: var(--gs-foreground);
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}

.gv-video-settings-panel .gv-encoder__copy {
  margin: 0 0 16px;
  max-width: 34rem;
  color: var(--gs-muted-foreground);
  font-size: 14px;
  text-align: center;
}

.gv-video-settings-panel .gv-encoder__copy-strong {
  color: var(--gs-foreground);
}

.gv-video-settings-panel .gv-encoder__providers {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  gap: 16px;
  margin-top: 8px;
}

.gv-video-settings-panel .gv-encoder__provider {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  background: var(--gs-surface);
  cursor: pointer;
}

.gv-video-settings-panel .gv-encoder__provider:hover {
  border-color: var(--gs-primary);
  box-shadow: var(--gs-shadow-sm);
}

.gv-video-settings-panel .gv-encoder__provider-link {
  margin-top: 10px;
  color: var(--gs-primary);
  font-size: 13px;
  font-weight: 600;
}

.gv-video-settings-panel .gv-encoder__toolbar {
  margin-bottom: 16px;
}

.gv-video-settings-panel .gv-encoder__add-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-radius: var(--gs-radius-md);
  background: var(--gs-primary);
  color: var(--gs-primary-foreground);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.gv-video-settings-panel .gv-encoder__menu {
  overflow: hidden;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  background: var(--gs-surface);
  box-shadow: var(--gs-shadow-md);
}

.gv-video-settings-panel .gv-encoder__menu-item {
  padding: 10px 14px;
  color: var(--gs-foreground);
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
}

.gv-video-settings-panel .gv-encoder__menu-item:hover {
  background: var(--gs-muted);
}

.gv-video-settings-panel .gv-encoder__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  width: 100%;
}

.gv-video-settings-panel .gv-encoder__account.storage-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: auto !important;
  height: auto !important;
  min-width: 0 !important;
  padding: 20px;
}

.gv-video-settings-panel .gv-encoder__account-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 72px;
}

.gv-video-settings-panel .gv-encoder__account-logo img {
  max-height: 100%;
}

.gv-video-settings-panel .gv-encoder__account-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--gs-border);
}

.gv-video-settings-panel .gv-encoder__account-name {
  overflow: hidden;
  color: var(--gs-foreground);
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  text-transform: capitalize;
  white-space: nowrap;
}

.gv-video-settings-panel .gv-encoder__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.gv-video-settings-panel .gv-encoder__actions .gs-button {
  min-width: 240px;
}

.gv-video-settings-panel .gv-encoder__help {
  margin: 20px 0 0;
  color: var(--gs-muted-foreground);
  font-size: 13px;
  text-align: center;
}

.gv-video-settings-panel .gv-encoder__help-link {
  color: var(--gs-primary);
}

.gv-video-settings-modal-actions {
  margin-top: 8px;
}

@media (max-width: 640px) {
  .gv-video-settings-panel .gv-encoder__grid {
    grid-template-columns: 1fr;
  }

  .gv-video-settings-panel .gv-encoder__actions .gs-button {
    min-width: 0;
    width: 100%;
  }
}
</style>
